import { render } from "./index.vue?vue&type=template&id=5e3e3377&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.scss?vue&type=style&index=0&id=5e3e3377&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3e3377"]])

export default __exports__